import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ReactChartkick, { LineChart } from 'react-chartkick'
import Chart from 'chart.js'

// material ui
import {MysidebarItemInput} from '../../components/Sidebar/SidebarItem/SidebarItemInput'
import {parseAIfunctionNameToNumber} from "../../../utils/elsc_utils"
import theme from "../../theme"
import log from 'loglevel'
import {t} from 'i18next'

ReactChartkick.addAdapter(Chart)

const styles = {
    root: {
        display: 'flex',
        marginTop: '10%',
    },
    ordinateControls: {
        display: 'flex',
        flexDirection: 'column',
    },
    abscisseControls: {
        display: 'flex',
        // justifyContent: 'space-around',
    },
    myTable: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    myTableColumn: {
        display: 'flex',
        flexDirection: 'column',
        // justifyContent: 'space-around',
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
}

class Graph extends Component {
    state = {
        x: {
            min: 10,
            max: 70,
        },
        y: {
            min: 50,
            max: 50,
        },
    }

    componentDidMount = () => {
        log.debug(this.state)
         log.debug(this.props)
        this.setState(prevState => ({
            ...prevState,
             context : this.getContext(),
             x : {min: this.getContext().x_min, max: this.getContext().x_max},
             y : {min: this.getContext().y_min, max: this.getContext().y_max},
        }))
        log.debug(this.state)
    }
    /**
     * Handles the changes for min and max values.
     * @param {string} cord
     * @param {string} border
     * @param {int} value
     */
    handleBorders = (cord, border, value, context) => {
        const newValue = this.state[cord][border] + value

        var local_min = 0
        var local_max = 100
        switch (cord) {
            case 'y':
                switch (border) {
                    case 'max':
                        local_min = context.y_max_min
                        local_max = context.y_max_max
                        break;
                
                    default:
                        local_min = context.y_min_min
                        local_max = context.y_min_max
                        break;
                }
                break;
        
            default:
                switch (border) {
                    case 'max':
                        local_min = 50
                        local_max = 100
                        break;
                
                    default:
                        local_min = 0
                        local_max = 50
                        break;
                }
                break;
        }

        log.debug(this.state)
        log.debug(newValue)
        var local_x = this.state.x
        var local_y = this.state.y
        if (local_min <= newValue && newValue <= local_max) {
            switch (cord) {
                case 'y':
                    switch (border) {
                        case 'max':
                            local_y.max += value
                          
                            break;
                    
                        default:
                            local_y.min += value
                            break;
                    }
                    break;
            
                default:
                    switch (border) {
                        case 'max':
                            local_x.max += value
                            break;
                    
                        default:
                            local_x.min += value
                            break;
                    }
                    break;
            }
            this.props.change(local_x, local_y, this.state.context)
        }
    }

    handleBorders2 = (cord, border, event, context) => {
        const newValue =  parseInt(event.target.value, 10)

        log.debug(this.state)
        log.debug(newValue)
        var local_x = this.state.x
        var local_y = this.state.y
        switch (cord) {
            case 'y':
                switch (border) {
                    case 'max':
                        local_y.max = newValue
                        
                        break;
                
                    default:
                        local_y.min = newValue
                        break;
                }
                break;
        
            default:
                switch (border) {
                    case 'max':
                        local_x.max = newValue
                        break;
                
                    default:
                        local_x.min = newValue
                        break;
                }
                break;
        }
        this.props.change(local_x, local_y, this.state.context)
    }

    myTestCallback = () =>{
        log.debug(this.state)
        this.props.change(this.state.x, this.state.y, this.state.context)
    }

    getContext = () => {
        let context = {
            index : 0,
            prefix_y_min: "",
            prefix_y_max: "",
            prefix_x_min: "AI min",
            prefix_x_max: "AI max",
            suffix_y:  "",     
            suffix_x: " %",
            modification: 0,
            x_min: this.props.ai.curveParams.x[1],
            x_max: this.props.ai.curveParams.x[2],
            y_min: 0,
            y_max: 0, 
            y_graphScale: 1,
            y_min_min : 0,
            y_min_max : 100,
            y_max_min : 50,
            y_max_max : 100,
            x_min_min : 0,
            x_min_max : 50,
            x_max_min : 50,
            x_max_max : 100,
        }


        switch (parseAIfunctionNameToNumber(this.props.ai.function)) {
            // none, shouldnt occure
            default:
            case 0:
                context.index = 0;
                break;

            // fan level
            case 1:
                context.index = 1;
                context.prefix_y_min = "Fan Lvl min";
                context.prefix_y_max = "Fan Lvl max";
                context.modification = 1;
                context.y_min = this.props.ai.curveParams.y_fanlevel[1];
                context.y_max = this.props.ai.curveParams.y_fanlevel[2];
                context.y_graphScale = 6/100;
                context.y_min_min = 0;
                context.y_min_max = 3;
                context.y_max_min = 3;
                context.y_max_max = 6
                break;

            //humi
            case 2:
                context.index = 2;
                context.prefix_y_min = "rF min";
                context.prefix_y_max = "rF max";
                context.suffix_y = "%"
                context.modification = 1;
                context.y_min = this.props.ai.curveParams.y_humi[1];
                context.y_max = this.props.ai.curveParams.y_humi[2];
                context.y_graphScale = 100/100;
                context.y_min_min = 0;
                context.y_min_max = 50;
                context.y_max_min = 50;
                context.y_max_max = 100
                break;

            //co2
            case 3:
                context.index = 3;
                context.prefix_y_min = "CO2 min";
                context.prefix_y_max = "CO2 max";
                context.suffix_y = "ppm"
                context.modification = 10;
                context.y_min = this.props.ai.curveParams.y_coco[1];
                context.y_max = this.props.ai.curveParams.y_coco[2];
                context.y_graphScale = 5000/100;
                context.y_min_min = 0;
                context.y_min_max = 1500;
                context.y_max_min = 1500;
                context.y_max_max = 5000;
                break;

            // Ti, Ta
            case 4:
                context.index = 4
                context.prefix_y_min = "T min";
                context.prefix_y_max = "T max";
                context.suffix_y = "°C"
                context.modification = 1;
                context.y_min = this.props.ai.curveParams.y_temp[1];
                context.y_max = this.props.ai.curveParams.y_temp[2];
                context.y_graphScale = 50/100;
                context.y_min_min = -50;
                context.y_min_max = 0;
                context.y_max_min = 0;
                context.y_max_max = 50;
                break;
            case 5:
                context.index = 5
                context.prefix_y_min = "T min";
                context.prefix_y_max = "T max";
                context.suffix_y = "°C"
                context.modification = 1;
                context.y_min = this.props.ai.curveParams.y_temp[1];
                context.y_max = this.props.ai.curveParams.y_temp[2];
                context.y_graphScale = 50/100;
                context.y_min_min = -50;
                context.y_min_max = 0;
                context.y_max_min = 0;
                context.y_max_max = 50;
                break;
        }
        return context;
    }
    


    render () {
        const { classes } = this.props

        return (
            <div>
                <div style={styles.root} >
                    <div style={styles.myTable}>                       
                        <MysidebarItemInput
                        width={'100%'}
                            propName={'x min'}
                            helperText={t('Misc.sidebar_item_helpertext_ai_curve_01') + `${this.getContext().x_min_min}`+ t('Misc.sidebar_item_helpertext_ai_curve_02') + `${this.getContext().x_min_max}`}
                            value={this.state.x.min}
                            label={this.getContext().prefix_x_min + ` ${this.getContext().suffix_x}`}
                            handleChange={event => this.handleBorders2('x', 'min', event, this.getContext())}
                            step={1}
                            error= {(this.props.rangeErrors.includes('x_min') || this.props.stepErrors.includes('x_min'))}
                            textFieldUnerline={styles.textFieldUnerline}
                                                textFieldFormLabel={styles.textFieldFormLabel}
                                                textFieldFocused={styles.textFieldFocused}
                        >
                        </MysidebarItemInput>
                        <MysidebarItemInput
                        width={'100%'}
                            propName={'x max'}
                            helperText={t('Misc.sidebar_item_helpertext_ai_curve_01') + `${this.getContext().x_max_min}`+ t('Misc.sidebar_item_helpertext_ai_curve_02') + `${this.getContext().x_max_max}`}
                            value={this.state.x.max}
                            label={this.getContext().prefix_x_max + ` ${this.getContext().suffix_x}`}
                            handleChange={event => this.handleBorders2('x', 'max', event, this.getContext())}
                            step={1}
                            error= {(this.props.rangeErrors.includes('x_max') || this.props.stepErrors.includes('x_max'))}
                            textFieldUnerline={styles.textFieldUnerline}
                                                textFieldFormLabel={styles.textFieldFormLabel}
                                                textFieldFocused={styles.textFieldFocused}
                        >
                        </MysidebarItemInput>
                    <MysidebarItemInput
                        width={'100%'}
                        propName={'y min'}
                        helperText={t('Misc.sidebar_item_helpertext_ai_curve_01') + `${this.getContext().y_min_min}`+ t('Misc.sidebar_item_helpertext_ai_curve_02') + `${this.getContext().y_min_max}`}
                        value={this.state.y.min}
                        label={this.getContext().prefix_y_min + ` ${this.getContext().suffix_y}`}
                        handleChange={event => this.handleBorders2('y', 'min', event, this.getContext())}
                        step={this.getContext().index === 3 ? 10 : 1}
                        error= {(this.props.rangeErrors.includes('y_min') || this.props.stepErrors.includes('y_min'))}
                        textFieldUnerline={styles.textFieldUnerline}
                                                textFieldFormLabel={styles.textFieldFormLabel}
                                                textFieldFocused={styles.textFieldFocused}
                    >
                    </MysidebarItemInput>
                        <MysidebarItemInput
                        width={'100%'}
                            propName={'y max'}
                            helperText={t('Misc.sidebar_item_helpertext_ai_curve_01') + `${this.getContext().y_max_min}`+ t('Misc.sidebar_item_helpertext_ai_curve_02') + `${this.getContext().y_max_max}`}
                            value={this.state.y.max}
                            label={this.getContext().prefix_y_max + ` ${this.getContext().suffix_y}`}
                            handleChange={event => this.handleBorders2('y', 'max', event, this.getContext())}
                            step={this.getContext().index === 3 ? 10 : 1}
                            error= {(this.props.rangeErrors.includes('y_max') || this.props.stepErrors.includes('y_max'))}
                            textFieldUnerline={styles.textFieldUnerline}
                                                textFieldFormLabel={styles.textFieldFormLabel}
                                                textFieldFocused={styles.textFieldFocused}
                        >
                        </MysidebarItemInput>


                    <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: '10%', position: 'center' }}>
                    <LineChart
                    colors={[theme.palette.primary.dark]}
                        data={[[0, this.getContext().y_min_min >= 0 ? 0 : this.getContext().y_min_min],
                        [this.state.x.min, this.getContext().y_min_min],
                        [this.state.x.min, this.state.y.min],
                        [this.state.x.max, this.state.y.max],
                        [100, this.state.y.max]]}
                        curve={false}
                        min={this.getContext().y_min_min}
                        max={this.getContext().y_max_max}
                        height={"100%"}
                        width={"90%"}

                        library={{
                            elements: {
                                point: {
                                    radius: 0,
                                },
                            },
                            scales: {
                                xAxes: [
                                    {
                                        ticks: {
                                            display: true,
                                        },
                                        gridLines: {
                                            display: true,
                                        },
                                    },
                                ],
                                yAxes: [
                                    {
                                        ticks: {
                                            display: true,
                                        },
                                        gridLines: {
                                            display: true,
                                        },
                                    },
                                ],
                            },
                        }}
                    />
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}

Graph.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    max: PropTypes.number,
    change: PropTypes.func,
}

Graph.defaultProps = {
    width: 500,
    height: 300,
    max: 10000,
    rangeErrors: []
}

export default Graph
